import "@/App.css";
import { useState, useCallback } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { LangProvider } from "@/context/LangContext";
import LoadingScreen from "@/components/LoadingScreen";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import MarqueeSection from "@/components/MarqueeSection";
import StatsCounter from "@/components/StatsCounter";
import Services from "@/components/Services";
import Packages from "@/components/Packages";
import Rentals from "@/components/Rentals";
import Equipment from "@/components/Equipment";
import VoiceOver from "@/components/VoiceOver";
import Testimonials from "@/components/Testimonials";
import Gallery from "@/components/Gallery";
import Features from "@/components/Features";
import Contact from "@/components/Contact";
import Partners from "@/components/Partners";
import Footer from "@/components/Footer";
import AdminPage from "@/pages/AdminPage";

function HomePage() {
  const [loaded, setLoaded] = useState(false);
  const onComplete = useCallback(() => setLoaded(true), []);

  return (
    <ReactLenis root options={{ lerp: 0.09, wheelMultiplier: 1, smoothWheel: true }}>
      <div className="bg-[#050505] min-h-screen selection:bg-[#E60000] selection:text-white">
        <div className="grain-overlay" aria-hidden="true" />
        {!loaded && <LoadingScreen onComplete={onComplete} />}
        <Header />
        <Hero />
        <MarqueeSection />
        <StatsCounter />
        <Services />
        <Packages />
        <Rentals />
        <Equipment />
        <VoiceOver />
        <Testimonials />
        <Gallery />
        <Partners />
        <Features />
        <Contact />
        <Footer />
      </div>
    </ReactLenis>
  );
}

function App() {
  return (
    <LangProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/admin" element={<AdminPage />} />
          </Routes>
        </BrowserRouter>
      </div>
    </LangProvider>
  );
}

export default App;
